export const Logo = ({ src, size = 32, className = "" }) => {
  if (src) {
    return (
      <img
        src={src}
        alt=""
        style={{ width: size, height: size }}
        className={`object-contain shrink-0 ${className}`}
      />
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={`shrink-0 ${className}`}
      aria-hidden="true"
    >
      <polygon
        points="50,4 93,27 93,73 50,96 7,73 7,27"
        fill="#FACC15"
        stroke="#1C1917"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      <polygon
        points="50,34 68,44.5 68,65.5 50,76 32,65.5 32,44.5"
        fill="none"
        stroke="#1C1917"
        strokeWidth="3"
      />
      <text
        x="50"
        y="60"
        textAnchor="middle"
        fontFamily="'Arial Black', Arial, sans-serif"
        fontWeight="900"
        fontSize="16"
        fill="#DC2626"
      >
        SM
      </text>
    </svg>
  );
};
